// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API, DATE_FILTER_NONE } = require('constants/index');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @ vendor
const moment = require('moment');

const getExpenseListRequest = () => ({
    type: actionTypes.OPENYOUNG_CARD_GET_EXPENSE_LIST_REQUEST
});

const getExpenseListSuccess = (expenseList) => ({
    type: actionTypes.OPENYOUNG_CARD_GET_EXPENSE_LIST_SUCCESS,
    payload:{
        expenseList
    }
});

const getExpenseListError = (error) => ({
    type: actionTypes.OPENYOUNG_CARD_GET_EXPENSE_LIST_ERROR,
    payload:{
        error
    }
});

const getExpenseList = (immCard) => (dispatch, getState) => {
    const immFilters = getState().openYoungCardExpenses.get('filters');
    const selectedMonth = immFilters.getIn(['date','selectedMonth']);
    const startDate = selectedMonth !== DATE_FILTER_NONE ? selectedMonth : moment().startOf('month').format(DATE_FORMAT_API);
    const endDate = moment().format(DATE_FORMAT_API);
    const panNumber = immCard.getIn(['interventionList',0,'pan']);
    const requestData = {
        query: {
            cards: [
                panNumber
            ],
            from: startDate,
            to: endDate
          }
    }

    dispatch(getExpenseListRequest());
    return APIPost({
        dispatch,
        endpoint: 'openYoungGetExpenseList',
        params: requestData
    })
    .then(response => dispatch(getExpenseListSuccess(response)))
    .catch(response => {
        if (!!response.error) {
            dispatch(getExpenseListError(response.error.description));
        } else {
            throw response;
        }
    });
}

const setOpenYoungCardExpenseFilter = filters => ({
    type: actionTypes.OPENYOUNG_CARD_GET_EXPENSE_LIST_APPLY_FILTER,
    payload: {
        filters
    }
});

const clearOpenYoungCardExpenseFilter = () => ({
    type: actionTypes.OPENYOUNG_CARD_GET_EXPENSE_LIST_CLEAR_FILTER
});

module.exports = {
    clearOpenYoungCardExpenseFilter,
    getExpenseList,
    getExpenseListError,
    getExpenseListRequest,
    getExpenseListSuccess,
    setOpenYoungCardExpenseFilter
}
